<template>
	<v-main :id="$vuetify.breakpoint.smAndDown ? 'room' : ''">
		<div id="custom">
			<v-btn
				:class="isShow ? '' : 'd-none'"
				style="background: #00000033; color: white; border: 2px solid; position:fixed; z-index: 205;"
				:style="{
					left: btnSkipLeft,
					bottom: '10px'
				}"
				@click="stopVideoTransition(!tmpSlug ? entity.introTransition : entity.outroTransition)"
			> SKIP</v-btn>
			<v-btn
				v-if="isShow && showBtnTransition"
				height="70px"
				class="rounded-circle"
				style="background: #00000033; color: white; border: 2px solid; position:fixed; z-index: 205;"
				:style="{
					left: 'calc(50vw - 25px)',
					bottom: '50vh'
				}"
				@click="playVideoTransition(!tmpSlug ? entity.introTransition : entity.outroTransition )"
			>
				<v-icon id="box-button-icon" large>mdi-play</v-icon>
			</v-btn>
			<div id="room-view" class="v-card v-card__text" style="padding: 0px; transform-origin: top left;" ref="roomView">
				<!-- set video transition -->
				<img
					v-if="((!tmpSlug && !$root.isVideo(entity.introTransition)) || (tmpSlug && !$root.isVideo(entity.outroTransition))) && isShow && showBtnTransition"
					:src="transitionThumbnail"
					style="position:fixed; z-index: 99;"
					width="960px"
					@load="calcScale()"
				/>
				<div v-if="(($root.isYoutubeUrl(entity.introTransition) && !tmpSlug) || (tmpSlug && $root.isYoutubeUrl(entity.outroTransition)))
					&& $store.state.showVideoTransition  && isShow"
				>
					<youtube
						:videoId="videoTransition"
						:player-vars="transitionYoutubeParams"
						style="pointer-events: none "
						width="960"
						height="530"
						ref="backgroundTransition"
						@ready="calcScale()"
						@ended="transitionEnds(true)"
						@playing="setShowBtnTransition(false)"
						@paused="setShowBtnTransition(true)"
					></youtube>
				</div>
				<div
					v-else-if="(($root.isVimeoUrl(entity.introTransition) && !tmpSlug) ||  (tmpSlug && $root.isVimeoUrl(entity.outroTransition))) && $store.state.showVideoTransition"
					ref="backgroundTransition"
				>
					<vimeo-player

						:class="isShow ? '' : 'd-none'"
						:video-url="videoTransition"
						:options="transitionVimeoParams"
						player-width="960"
						player-height="auto"
						style="pointer-events: none "
						@loaded="calcScale()"
						@ended="transitionEnds(false)"
						@playing="setShowBtnTransition(false)"
						@pause="setShowBtnTransition(true)"
						ref="backgroundTransitionVimeo"
					>
					</vimeo-player>
				</div>
				<video
					v-else-if="$store.state.showVideoTransition"
					:class="isShow ? '' : 'd-none'"
					id="videoTransition"
					style="display: block"
					width="960px"
					preload="auto"
					muted
					playsinline
					disablepictureinpicture
					type="video/mp4"
					ref="backgroundTransition"
				>
				</video>

				<!-- Set Background -->
				<img
					v-if="$root.isImage(entity.background)"
					:class="isShow ? 'd-none' : ''"
					:src="$root.asset(entity.background)"
					style="display: block"
					width="960px"
					ref="background"
					@load="calcScale()"
				/>
				<video
					v-else-if="$root.isVideo(entity.background)"
					:class="isShow ? 'd-none' : ''"
					id="video"
					style="display: block"
					width="960px"
					preload="auto"
					autoplay="autoplay"
					muted
					playsinline
					disablepictureinpicture
					loop="loop"
					:src="$root.asset(entity.background)"
					type="video/mp4"
					ref="background"
					@load="calcScale()"
				>
				</video>
				<div v-else-if="$root.isYoutubeUrl(entity.background)" ref="background">
					<template v-if="!isShow">
						<youtube
							:class="isShow ? 'd-none' : ''"
							:videoId="$root.getYoutubeId(entity.background, backgroundYoutubeParams)"
							:player-vars="backgroundYoutubeParams"
							style="pointer-events: none;"
							width="960"
							height="530"
							ref="backgroundYoutube"
							@ready="calcScale()"
						></youtube>
					</template>
				</div>
				<div v-else-if="$root.isVimeoUrl(entity.background)" ref="background">
					<template v-if="!isShow">
						<vimeo-player
							:video-url="entity.background"
							:options="backgroundVimeoParams"
							style="pointer-events: none "
							player-width="960"
							player-height="auto"
							@loaded="calcScale()"
						></vimeo-player>
					</template>
				</div>
				<div v-for="(item, idxItem) in entity.linkToDataList" :key="idxItem*item.id">
					<v-tooltip v-if="item.tooltip && item.tooltip.show" :color="item.tooltip.backgroundColor + ' !important'" top>
						<template v-slot:activator="{ on, attrs }">
							<img
								v-if="item.type === 'Image'"
								:src="$root.asset(item.value)"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 1,
									width: item.width + 'px',
									height: item.height + 'px',
									objectFit: $root.setBackgroundSize(item.subType),
									objectPosition: $root.setBackgroundPosition(item),
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute',
								}"
								v-on="on"
								v-bind="attrs"
							/>
							<iframe
								v-else-if="item.type === 'Video' && !isShow"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 1,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute',
								}"
								frameborder="0"
								allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
								scrolling="0"
								:src="$root.asset(item.value)"
								v-on="on"
								v-bind="attrs"
								allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
							>
							</iframe>
							<div
								v-else-if="item.type === 'Zoom' && item.target === 'Embed' && isShowZoomEmbed == true"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute'
								}"
								v-on="on"
								v-bind="attrs"
							>
								<v-card :height="item.height + 'px'" :style="{overflow: item.height < 295 ? 'auto' : 'none'}">
									<div id="iframe-container"
										:style="{
											height: '100%',
											transform: 'scale(0.5)',
											transformOrigin: 'left top'
										}"
									>
										<iframe
											id="iframeZoom"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
												width: (item.width * 2) + 'px',
												height: (item.height * 2) -36 + 'px',
												transform:
													'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												minHeight: '560px',
												marginTop: '20px'
											}"
											frameborder="0"
											allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
											scrolling="0"
											:src="
												baseLocation +
												'/zoom.jsp?nickname=' +
												$store.state.principal.firstName + ' ' + $store.state.principal.lastName +
												'&email=' +
												$store.state.principal.email +
												'&meetingId=' +
												(item.value.includes('pwd=') ? item.value.substring(item.value.indexOf('j/') + 2, item.value.indexOf('?')) : item.value.substring(item.value.indexOf('j/') + 2, item.value.length)) +
												'&role=' +
												0 +
												'&password=' +
												(item.value.includes('pwd=') ? item.value.substring(item.value.indexOf('pwd=') + 4, item.value.length) : 'null') +
												'&disablePreview=' + ((item.disablePreview == null || item.disablePreview === '') ? true : item.disablePreview)
											"
											allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
										></iframe>
									</div>
								</v-card>
							</div>
							<div
								v-else-if="item.type === 'Teams' && item.target === 'Embed'"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute'
								}"
								v-on="on"
								v-bind="attrs"
							>
								<v-card :height="item.height + 'px'" :style="{overflow: item.height < 295 ? 'auto' : 'none'}">
									<div id="iframe-container"
										:style="{
											height: '100%',
											transform: 'scale(0.5)',
											transformOrigin: 'left top'
										}"
									>
										<iframe
											id="iframeZoom"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
												width: (item.width * 2) + 'px',
												height: (item.height * 2) -36 + 'px',
												transform:
													'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												minHeight: '560px',
												marginTop: '20px'
											}"
											frameborder="0"
											allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
											scrolling="0"
											:src="$root.getUrlTeamsWithLink(item.value)"
											allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
										></iframe>
									</div>
								</v-card>
							</div>
							<div
								v-else-if="item.type === 'Training' && item.target === 'Embed'"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute'
								}"
								v-on="on"
								v-bind="attrs"
							>
								<iframe
									class="d-none d-sm-flex"
									style="border:1px solid #e0e0e0; transform: scale(0.5); transformOrigin: left top; position: absolute"
									:width=item.width*2
									:height=item.height*2
									:src='$vtrainingurl + "/account/?guid=" + vTrainingUserGUID + "&view=training&categories=" + item.categories.filter(value => userModules.includes(value+"")).join("-")'
									allow="camera;microphone"
									allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
								>
								</iframe>
								<div
									class="d-flex justify-center align-center"
									style="height:100%"
								>
									<v-btn
										v-if="!item.backgroundImage"
										class="hotspot_btn d-flex d-sm-none"
										absolute
										:color="item.backgroundColor"
										:style="{
											zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
											transform:
												'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
											textTransform: 'none',
											borderStyle:
												item.borderWidth === 'none'
													? item.borderWidth
													: 'solid',
											borderRadius: item.borderRadius,
											borderWidth: item.borderWidth,
											borderColor: item.borderColor,
										}"
										@click="showTrainingDialog(item)"
									>
										<div v-html="item.value"></div>
									</v-btn>
									<v-btn
										v-else-if="item.backgroundImage"
										class="hotspot_btn d-flex d-sm-none"
										absolute
										:style="{
											backgroundImage: 'url(' + item.backgroundImage + ')',
											zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
											transform:
												'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
											textTransform: 'none',
											borderStyle:
												item.borderWidth === 'none'
													? item.borderWidth
													: 'solid',
											borderRadius: item.borderRadius,
											borderWidth: item.borderWidth,
											borderColor: item.borderColor,
										}"
										@click="showTrainingDialog(item)"
										v-on="on"
										v-bind="attrs"
									>
										<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
									</v-btn>
								</div>
							</div>
							<div
								v-else-if="item.type === 'Completed_Training' && item.target === 'Embed'"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute'
								}"
								v-on="on"
								v-bind="attrs"
							>
								<iframe
									style="border:1px solid #e0e0e0; transform: scale(0.5); transformOrigin: left top; position: absolute"
									:width=item.width*2
									:height=item.height*2
									:src='$vtrainingurl + "/account/?guid=" + vTrainingUserGUID + "&view=complete"'
									allow="camera;microphone"
									allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
								>
								</iframe>
							</div>
							<div
								v-else-if="item.type === 'Text'"
								class="hotspot_text"
								:class="isShow ? 'd-none' : ''"
								v-html="item.value"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute',
									backgroundColor: item.backgroundColor,
									borderStyle:
										item.borderWidth === 'none'
											? item.borderWidth
											: 'solid',
									borderWidth: item.borderWidth,
									borderColor: item.borderColor,
									padding: (item.padding ? item.padding : '0') + 'px',
								}"
								v-on="on"
								v-bind="attrs"
							></div>
							<div
								v-else-if="
									item.type === 'Embed_HTML' && item.target === 'Embed'
								"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 1,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute',
									overflow: 'hidden',
								}"
								v-on="on"
								v-bind="attrs"
								v-append="replaceContent(item.valueRender ? item.valueRender : item.value)"
							></div>
							<v-btn
								v-else-if="item.type === 'Button' && !item.backgroundImage"
								class="hotspot_btn"
								:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
								absolute
								:color="item.backgroundColor"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									textTransform: 'none',
									borderStyle:
										item.borderWidth === 'none'
											? item.borderWidth
											: 'solid',
									borderRadius: item.borderRadius,
									borderWidth: item.borderWidth,
									borderColor: item.borderColor,
								}"
								v-on="on"
								v-bind="attrs"
							>
								<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
							</v-btn>
							<v-btn
								v-else-if="item.type === 'Button' && item.backgroundImage"
								class="hotspot_btn"
								:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
								absolute
								:style="{
									backgroundImage: 'url(' + item.backgroundImage + ')',
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									textTransform: 'none',
									borderStyle:
										item.borderWidth === 'none'
											? item.borderWidth
											: 'solid',
									borderRadius: item.borderRadius,
									borderWidth: item.borderWidth,
									borderColor: item.borderColor,
								}"
								v-on="on"
								v-bind="attrs"
							>
								<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
							</v-btn>
							<v-btn
								v-else-if="item.type === 'Back_Button' && !item.backgroundImage"
								class="hotspot_btn"
								:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
								absolute
								:color="item.backgroundColor"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									textTransform: 'none',
									borderStyle:
										item.borderWidth === 'none'
											? item.borderWidth
											: 'solid',
									borderRadius: item.borderRadius,
									borderWidth: item.borderWidth,
									borderColor: item.borderColor,
								}"
								v-on="on"
								v-bind="attrs"
								@click="previousPage()"
							>
								<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
							</v-btn>
							<v-btn
								v-else-if="item.type === 'Back_Button' && item.backgroundImage"
								class="hotspot_btn"
								:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
								absolute
								:style="{
									backgroundImage: 'url(' + item.backgroundImage + ')',
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									textTransform: 'none',
									borderStyle:
										item.borderWidth === 'none'
											? item.borderWidth
											: 'solid',
									borderRadius: item.borderRadius,
									borderWidth: item.borderWidth,
									borderColor: item.borderColor,
								}"
								v-on="on"
								v-bind="attrs"
								@click="previousPage()"
							>
								<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
							</v-btn>
							<a
								v-else-if="item.type === 'File_Download'"
								@click="fileDownload(item)"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' +
										item.skewX +
										'deg,' +
										item.skewY +
										'deg)',
									position: 'absolute'
								}"
								v-on="on"
								v-bind="attrs"
								></a>
							<a
								v-else
								link
								ripple="false"
								class="room-link"
								:class="isShow ? 'd-none' : ''"
								@click="linkTo(item)"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 3,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								}"
								v-on="on"
								v-bind="attrs"
							></a>
						</template>
						<div
							class="text-center"
							:style="{color: item.tooltip.fontColor}"
							v-html="item.tooltip.value.replace(/(?:\r\n|\r|\n)/g, '<br>')">
						</div>
					</v-tooltip>
					<div v-else>
						<img
							v-if="item.type === 'Image'"
							:src="$root.asset(item.value)"
							:class="isShow ? 'd-none' : ''"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 1,
								width: item.width + 'px',
								height: item.height + 'px',
								objectFit: $root.setBackgroundSize(item.subType),
								objectPosition: $root.setBackgroundPosition(item),
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute',
							}"
						/>
						<iframe
							v-else-if="item.type === 'Video' && !isShow"
							:class="isShow ? 'd-none' : ''"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 1,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute',
							}"
							frameborder="0"
							allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
							scrolling="0"
							:src="$root.asset(item.value)"
							allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
						>
						</iframe>
						<div
							v-else-if="item.type === 'Zoom' && item.target === 'Embed' && isShowZoomEmbed == true"
							:class="isShow ? 'd-none' : ''"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute'
							}"
						>
							<v-card :height="item.height + 'px'" :style="{overflow: item.height < 295 ? 'auto' : 'none'}">
								<div id="iframe-container"
									:style="{
										height: '100%',
										transform: 'scale(0.5)',
										transformOrigin: 'left top'
									}"
								>
									<iframe
										id="iframeZoom"
										:style="{
											zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
											width: (item.width * 2) + 'px',
											height: (item.height * 2) -36 + 'px',
											transform:
												'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
											position: 'absolute',
											minHeight: '560px',
											marginTop: '20px'
										}"
										frameborder="0"
										allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
										scrolling="0"
										:src="
											baseLocation +
											'/zoom.jsp?nickname=' +
											$store.state.principal.firstName + ' ' + $store.state.principal.lastName +
											'&email=' +
											$store.state.principal.email +
											'&meetingId=' +
											(item.value.includes('pwd=') ? item.value.substring(item.value.indexOf('j/') + 2, item.value.indexOf('?')) : item.value.substring(item.value.indexOf('j/') + 2, item.value.length)) +
											'&role=' +
											0 +
											'&password=' +
											(item.value.includes('pwd=') ? item.value.substring(item.value.indexOf('pwd=') + 4, item.value.length) : 'null') +
											'&disablePreview=' + ((item.disablePreview == null || item.disablePreview === '') ? true : item.disablePreview)
										"
										allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
									></iframe>
								</div>
							</v-card>
						</div>
						<div
							v-else-if="item.type === 'Teams' && item.target === 'Embed'"
							:class="isShow ? 'd-none' : ''"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute'
							}"
						>
							<v-card :height="item.height + 'px'" :style="{overflow: item.height < 295 ? 'auto' : 'none'}">
								<div id="iframe-container"
									:style="{
										height: '100%',
										transform: 'scale(0.5)',
										transformOrigin: 'left top'
									}"
								>
									<iframe
										id="iframeZoom"
										:style="{
											zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
											width: (item.width * 2) + 'px',
											height: (item.height * 2) -36 + 'px',
											transform:
												'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
											position: 'absolute',
											minHeight: '560px',
											marginTop: '20px'
										}"
										frameborder="0"
										allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
										scrolling="0"
										:src="$root.getUrlTeamsWithLink(item.value)"
										allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
									></iframe>
								</div>
							</v-card>
						</div>
						<div
							v-else-if="item.type === 'Training' && item.target === 'Embed'"
							:class="isShow ? 'd-none' : ''"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute'
							}"
						>
							<iframe
								class="d-none d-sm-flex"
								style="border:1px solid #e0e0e0; transform: scale(0.5); transformOrigin: left top; position: absolute"
								:width=item.width*2
								:height=item.height*2
								:src='$vtrainingurl + "/account/?guid=" + vTrainingUserGUID + "&view=training&categories=" + item.categories.filter(value => userModules.includes(value+"")).join("-")'
								allow="camera;microphone"
								allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
							>
							</iframe>
							<div
								class="d-flex justify-center align-center"
								style="height:100%"
							>
								<v-btn
									v-if="!item.backgroundImage"
									class="hotspot_btn d-flex d-sm-none"
									absolute
									:color="item.backgroundColor"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
										transform:
											'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle:
											item.borderWidth === 'none'
												? item.borderWidth
												: 'solid',
										borderRadius: item.borderRadius,
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
									}"
									@click="showTrainingDialog(item)"
								>
									<div v-html="item.value"></div>
								</v-btn>
								<v-btn
									v-else-if="item.backgroundImage"
									class="hotspot_btn d-flex d-sm-none"
									absolute
									:style="{
										backgroundImage: 'url(' + item.backgroundImage + ')',
										zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
										transform:
											'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle:
											item.borderWidth === 'none'
												? item.borderWidth
												: 'solid',
										borderRadius: item.borderRadius,
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
									}"
									@click="showTrainingDialog(item)"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
							</div>
						</div>
						<div
							v-else-if="item.type === 'Completed_Training' && item.target === 'Embed'"
							:class="isShow ? 'd-none' : ''"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 999,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute'
							}"
						>
							<iframe
								style="border:1px solid #e0e0e0; transform: scale(0.5); transformOrigin: left top; position: absolute"
								:width=item.width*2
								:height=item.height*2
								:src='$vtrainingurl + "/account/?guid=" + vTrainingUserGUID + "&view=complete"'
								allow="camera;microphone"
								allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
							>
							</iframe>
						</div>
						<div
							v-else-if="item.type === 'Text'"
							class="hotspot_text"
							:class="isShow ? 'd-none' : ''"
							v-html="item.value"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute',
								backgroundColor: item.backgroundColor,
								borderStyle:
									item.borderWidth === 'none'
										? item.borderWidth
										: 'solid',
								borderWidth: item.borderWidth,
								borderColor: item.borderColor,
								padding: (item.padding ? item.padding : '0') + 'px',
							}"
						></div>
						<div
							v-else-if="
								item.type === 'Embed_HTML' && item.target === 'Embed'
							"
							:class="isShow ? 'd-none' : ''"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 1,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute',
								overflow: 'hidden',
							}"
							v-append="replaceContent(item.valueRender ? item.valueRender : item.value)"
						></div>
						<v-btn
							v-else-if="item.type === 'Button' && !item.backgroundImage"
							class="hotspot_btn"
							:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
							absolute
							:color="item.backgroundColor"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								textTransform: 'none',
								borderStyle:
									item.borderWidth === 'none'
										? item.borderWidth
										: 'solid',
								borderRadius: item.borderRadius,
								borderWidth: item.borderWidth,
								borderColor: item.borderColor,
							}"
						>
							<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
						</v-btn>
						<v-btn
							v-else-if="item.type === 'Button' && item.backgroundImage"
							class="hotspot_btn"
							:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
							absolute
							:style="{
								backgroundImage: 'url(' + item.backgroundImage + ')',
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								textTransform: 'none',
								borderStyle:
									item.borderWidth === 'none'
										? item.borderWidth
										: 'solid',
								borderRadius: item.borderRadius,
								borderWidth: item.borderWidth,
								borderColor: item.borderColor,
							}"
						>
							<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
						</v-btn>
						<v-btn
							v-else-if="item.type === 'Back_Button' && !item.backgroundImage"
							class="hotspot_btn"
							:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
							absolute
							:color="item.backgroundColor"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								textTransform: 'none',
								borderStyle:
									item.borderWidth === 'none'
										? item.borderWidth
										: 'solid',
								borderRadius: item.borderRadius,
								borderWidth: item.borderWidth,
								borderColor: item.borderColor,
							}"
							v-on="on"
							v-bind="attrs"
							@click="previousPage()"
						>
							<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
						</v-btn>
						<v-btn
							v-else-if="item.type === 'Back_Button' && item.backgroundImage"
							class="hotspot_btn"
							:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
							absolute
							:style="{
								backgroundImage: 'url(' + item.backgroundImage + ')',
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								textTransform: 'none',
								borderStyle:
									item.borderWidth === 'none'
										? item.borderWidth
										: 'solid',
								borderRadius: item.borderRadius,
								borderWidth: item.borderWidth,
								borderColor: item.borderColor,
							}"
							v-on="on"
							v-bind="attrs"
							@click="previousPage()"
						>
							<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
						</v-btn>
						<a
								v-else-if="item.type === 'File_Download'"
								@click="fileDownload(item)"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' +
										item.skewX +
										'deg,' +
										item.skewY +
										'deg)',
									position: 'absolute'
								}"
							></a>
							<div
							v-else-if="item.type === 'Private_Chat' && item.privateShowType === 'Embed'"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 1,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute'
							}"
						>
							<iframe
								:src="$vchaturl + '/frontend/?e=' + $store.state.principal.chatEventToken +
									'&r=' + item.privateChatRoom +
									'&u=' + $store.state.principal.chatUserToken"
								style="height:125%; width: 125%; zoom: 1; -moz-transform: scale(0.75);-moz-transform-origin: 0 0;-o-transform: scale(0.75);-o-transform-origin: 0 0;-webkit-transform: scale(0.75);-webkit-transform-origin: 0 0;"
								allow="camera; microphone;"
								allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
							></iframe>
						</div>
						<div
							v-else-if="item.type === 'Training_Clinic_Admin' && item.target === 'Embed'"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 1,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
								position: 'absolute'
							}"
						>
							<iframe
								:src="$vtrainingurl + '/account/manage-employees/?guid=' + vTrainingUserGUID +'&view=manage-employees'"
								style="height:125%; width: 125%; zoom: 1; -moz-transform: scale(0.75);-moz-transform-origin: 0 0;-o-transform: scale(0.75);-o-transform-origin: 0 0;-webkit-transform: scale(0.75);-webkit-transform-origin: 0 0;"
								allow="camera; microphone;"
								allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
							></iframe>
						</div>
						<a
							v-else
							link
							ripple="false"
							class="room-link"
							:class="isShow ? 'd-none' : ''"
							@click="linkTo(item)"
							:style="{
								zIndex: layerMode == true ? entity.linkToDataList.length - idxItem : 3,
								width: item.width + 'px',
								height: item.height + 'px',
								top: item.posY + 'px',
								left: item.posX + 'px',
								transform:
									'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
							}"
							v-on="on"
							v-bind="attrs"
						></a>
					</div>
				</div>
				<div
					v-if="
						entity.dataMap.isExhibitionHall &&
						boothSelectedList.length > 0 &&
						!isShow
					"
					class="d-flex justify-center"
					:class="isShow ? 'd-none' : ''"
					style="position: absolute; z-index:5; top: 0; right: 0, bottom:0; width: 960px; max-height:100%;"
				>
					<v-row class="d-flex justify-center mx-0">
						<v-col
							class="my-4"
							cols="8"
							style="
								background-color: rgba(0, 0, 0, 0.5);
								overflow-y: auto;
								max-height: 95%;
							"
						>
							<v-list
								style="background-color: rgba(0, 0, 0, 0)"
								dark
								dense
							>
								<v-text-field
									class=""
									flat
									label="Search"
									prepend-inner-icon="search"
									solo-inverted
									v-model="search"
									clearable
									@click:clear="clearSearch"
								></v-text-field>
								<div
									v-for="(item, idxItem) in filteredBoothSelectedList"
									:key="idxItem"
								>
									<v-list-item
										v-if="item.boothBackground.type == 'Color'"
										:to="
											'/' +
											tenantSlug +
											'/' +
											experienceSlug +
											'/booth/' +
											item.id
										"
										v-bind:style="{backgroundColor: item.boothBackground.color}"
									>
										<v-list-item-avatar color="grey lighten-2">
											<v-img
												:src="$root.asset(item.logo)"
											></v-img>
										</v-list-item-avatar>
										<v-list-item-content>{{
											item.name
										}}</v-list-item-content>
										<v-list-item-action></v-list-item-action>
									</v-list-item>
									<v-list-item
										v-else-if="item.boothBackground.type == 'Upload'"
										:to="
											'/' +
											tenantSlug +
											'/' +
											experienceSlug +
											'/booth/' +
											item.id
										"
										v-bind:style="{backgroundImage: 'url(' + item.boothBackground.image + ')'}"
									>
										<v-list-item-avatar color="grey lighten-2">
											<v-img
												:src="$root.asset(item.logo)"
											></v-img>
										</v-list-item-avatar>
										<v-list-item-content>{{
											item.name
										}}</v-list-item-content>
										<v-list-item-action></v-list-item-action>
									</v-list-item>
									<v-divider></v-divider>
								</div>
							</v-list>
						</v-col>
					</v-row>
				</div>
				<div
					v-if="entity.dataMap.isPosterRoom && entity.dataMap.posterSelected != null && entity.dataMap.posterSelected.length > 0  && !isShow"
					class="d-flex justify-center"
					id="poster-view"
					:class="isShow ? 'd-none' : ''"
					style="position: absolute; z-index:5; top: 18%; right: 0, bottom:0; max-height:100%; transform-origin: left top 0px;transform: scale(0.5);"
				>
					<v-row>
						<v-col cols="12" style="padding: 0px 40px">
							<div style="background-color: #00000090;">
								<v-row>
									<v-col class="d-flex justify-start ml-3">
										<v-btn
											@click="goToPreviousPage"
											:style="[posterNxtPrev_BtnStyle]"
											color="#717171"
											dark
											depressed
											:disabled="pageChange"
										>
											<v-icon>mdi-chevron-left</v-icon> 
											Previous
										</v-btn>
									</v-col>
									
									<v-col class="d-flex justify-center">
										<v-text-field
											class="poster_search"
											flat
											placeholder="Search"
											prepend-inner-icon="search"
											solo-inverted
											v-model="searchPoster"
											clearable
											@click:clear="cleanSearchPoster"
											hide-details=""
											background-color="#00000070"
											color="white"
											v-on:keyup="getPosterSelectedList() "
											style="width: 30%; margin: auto"
										></v-text-field>
									</v-col>

									<v-col class="d-flex justify-end mr-3">
										<v-btn 
											@click="goToNextPage"
											:style="[posterNxtPrev_BtnStyle]"
											color="#717171" 
											dark 
											depressed 
											:disabled="pageChange"
										>
											Next
											<v-icon>mdi-chevron-right</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</div>
						</v-col>
						<v-col cols="12" style="padding: 0px 40px; max-height: 100%">
							<div style="overflow: hidden auto; max-height: 153%; background-color:#00000090;">
							<v-carousel 
								v-model="posterPage" 
								height="100%" 
								hide-delimiters 
								style="transform: scale(0.75); transform-origin: left top; width: 132%; max-width: 132%"
								:show-arrows="false"
							>
							<!-- next-icon="mdi-arrow-right-circle" 
								prev-icon="mdi-arrow-left-circle" -->
								
								<v-carousel-item
									v-for="page in Math.ceil(posterList.length/4)"
									:key="page"
								>
									<v-row class="justify-center mx-0;">
										<v-col cols="4" v-for="(poster, idxPoster) in getPosterByPage(page)" :key="idxPoster" >
												<v-card style="background-color: #00000000" @click="posterShow(poster)">
													<v-card-title class="justify-center">
														<span class="headline" style="color: white">{{ poster.name }}</span>
													</v-card-title>
													<v-card-text>
														
														<div :style="[posterByPageStyle, { backgroundColor: poster.backgroundColor }]" >
															<v-row v-for="(item, index) in poster.posterDataList" :key="index" style="margin: 5px; padding: 0px">
																<v-col v-for="(item1, index1) in item" :key="index1" :cols="12 / item.length" style="padding: 1px">
																	<v-btn
																		v-if="item1.type == 'URL FIELD'"
																		width="100%"
																		:color="item1.backgroundColor"
																		:style="{ color: item1.fontColor }"
																	>
																		{{ item1.label }}
																	</v-btn>
																	<v-btn
																		v-else-if="item1.type == 'FILE DOWNLOAD'"
																		width="100%"
																		:color="item1.backgroundColor"
																		:style="{ color: item1.fontColor }"
																	>
																		{{ item1.label }}
																		<v-icon :color="item1.iconColor" medium>mdi-download</v-icon>
																	</v-btn>
																	<div
																		v-else-if="item1.type == 'TEXT'"
																		v-html="item1.value"
																		:style="{
																			backgroundColor: item1.backgroundColor,
																			border: '1px solid ' + item1.backgroundColor
																		}"
																		style="border: 1px solid black; padding: 10px 10px 0px 10px"
																	></div>
																	<v-carousel v-else-if="item1.type == 'GALLERY'" 
																	:class="posterCarousel_BtnStyle"
																	hide-delimiters 
																	height="368" 
																	:show-arrows="item1.images.length > 1 ? true : false">
																		<v-carousel-item
																			v-for="(image, idxImage) in item1.images"
																			class="galley_poster"
																			:key="idxImage"
																			:src="$root.asset(image)"
																			reverse-transition="fade"
																			transition="fade"
																		>
																		</v-carousel-item>
																	</v-carousel>
																	<iframe
																		v-else-if="item1.type == 'VIDEO'"
																		id="video_poster"
																		:src="$root.asset(item1.value)"
																		style="pointer-events: none"
																		frameborder="0"
																		allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'"
																		scrolling="0"
																		width="100%"
																		height="300px"
																		allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
																	>
																	</iframe>
																</v-col>
															</v-row>
														</div>
													</v-card-text>
												</v-card>
										</v-col>
									</v-row>
								</v-carousel-item>
							</v-carousel>
							</div>
						</v-col>
					</v-row>
				</div>
			</div>
		</div>

		<div id="bannerRotating" :class="isShow ? 'd-none' : ''" style="position: sticky; left: 0;" :style="{ marginTop: bannerRotatingMarginTop }"
			v-if="
					(entity.dataMap.isExhibitionHall &&
					entity.dataMap.bannerRotatingVideo &&
					!isShow) || $store.state.isPoweredBy
				"
		>
			<v-row
				v-if="
					(entity.dataMap.isExhibitionHall &&
					entity.dataMap.bannerRotatingVideo &&
					!isShow)
				"
				class="d-flex justify-space-around pa-2 mx-0"
				:class="isShow ? 'd-none' : ''"
				style="background-color: black"
			>
				<v-col cols="12" sm="4" v-if="boothList.length > 0">
					<v-card height="306" tile>
						<v-data-iterator
							:items="boothList"
							hide-default-footer
							:items-per-page="100"
						>
							<template v-slot:header>
								<v-toolbar color="#416d74" height="56" dark flat>
									<v-toolbar-title
										>Exhibitors Index</v-toolbar-title
									>
								</v-toolbar>
							</template>

							<template v-slot:default="props">
								<v-card class="scrollable" max-height="250" tile>
									<v-list max-height="250" dense>
										<div
											v-for="(item, idxItem) in props.items"
											:key="idxItem"
										>
											<v-list-item
												:to="
													'/' +
													tenantSlug +
													'/' +
													experienceSlug +
													'/booth/' +
													item.value
												"
											>
												<v-list-item-content>{{
													item.name
												}}</v-list-item-content>
											</v-list-item>
											<v-divider></v-divider>
										</div>
									</v-list>
								</v-card>
							</template>
						</v-data-iterator>
					</v-card>
				</v-col>
				<v-col cols="12" sm="4">
					<v-card
						class="d-flex flex-justify align-center pa-4"
						height="306"
						tile
					>
						<video
							v-if="
								entity.dataMap.bannerRotatingVideo &&
								$root.isVideo(entity.dataMap.bannerRotatingVideo)
							"
							style="width: 100%; height: 100%; right: 0; bottom: 0"
							preload="auto"
							autoplay="autoplay"
							muted
							playsinline
							disablepictureinpicture
							loop="loop"
							:src="$root.asset(entity.dataMap.bannerRotatingVideo)"
							type="video/mp4"
						>
						</video>
						<v-img
							contain
							v-else
							max-height="306"
							:src="$root.asset(boothLogo)"
						></v-img>
					</v-card>
				</v-col>
				<v-col cols="12" sm="4">
					<v-card
						class="d-flex flex-justify align-center pa-4"
						height="306"
						tile
					>
						<v-img
							v-if="experience.logo"
							max-height="306"
							contain
							:src="$root.asset(experience.logo)"
						></v-img>
					</v-card>
				</v-col>
			</v-row>
			<v-row v-if="$store.state.isPoweredBy && bannerRotatingMarginTop != '0px'" :style="{width: divFooterWidth}">
				<v-col cols="12" sm="12">
					<div id="v-footer" style="height: 50px" :style="{width: footerWidth}" v-if="$store.state.footerText === ''">
						<p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
					</div>

                    <div id="v-footer" style="height: 50px" :style="{width: footerWidth}" v-else>
						<p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
					</div>
				</v-col>
			</v-row>
		</div>

		<v-dialog
            eager
            v-model="dialog.show"
            no-click-animation
            persistent
            transition="dialog-bottom-transition"
            content-class="pa-0 col-12 hide-box-shadow"
			:fullscreen="isMaxDialog"
            style="overflow: hidden"
            @click="iframeControl('')"
        >
            <v-card
				style="height:100%; margin: auto; padding: 0px"
				:style="{backgroundColor: dialog.transparent, width: isMobile ? '100% !important;' : '70% !important'}"
				:tile="$vuetify.breakpoint.mobile">

				<v-card-title class="headline" :style="{backgroundColor: isMedspa ? '#faa534' : dialog.backgroundColor, color: isMedspa ? '#ffffff' : '#000000'}">
					{{ dialog.title }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="isMaxDialog == false ? maximizeDialogUrl() : minimizeDialogUrl()"
                    >
                        <v-icon v-if="isMaxDialog">mdi-window-restore</v-icon>
						<v-icon v-else>mdi-window-maximize</v-icon>
                    </v-btn>
					<v-btn
                        icon
                        @click="closeDialog(), iframeControl('')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <img
                    v-if="$root.isImage(dialog.content)"
                    :src="$root.asset(dialog.content)"
                    :style="{
                        width: '100%',
                        height: '100%',
                        right: '0',
                        bottom: '0',
                        backgroundColor: dialog.backgroundColor
                    }"
                />
                <div v-else ref="embedHtmlContainer" id="iframe-container" :style="{backgroundColor: dialog.backgroundColor, overflow: 'auto'}">
                    <div
                        v-if="dialog.contentType === 'Embed_HTML'"
                        v-append="replaceContent(dialog.content)"
                        class="hotspot_embed_html"
                        id="embedHtml"
                    ></div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog
            eager
            v-model="dialogUrl.show"
            no-click-animation
            persistent
            transition="dialog-bottom-transition"
            content-class="pa-0 col-12 hide-box-shadow"
			:fullscreen="isMaxDialog"
            style="overflow: hidden"
            @click="iframeControl('')"
        >
            <v-card
				style="height:600px; margin: auto; padding: 0px;"
				:style="{height: '100%', width: isMobile ? '100% !important;' : '70% !important'}"
				:tile="$vuetify.breakpoint.mobile">
                <v-card-title class="headline" :style="{backgroundColor: isMedspa ? '#faa534' : dialog.backgroundColor, color: isMedspa ? '#ffffff' : '#000000'}">
                    {{ dialogUrl.title }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="isMaxDialog == false ? maximizeDialogUrl() : minimizeDialogUrl()"
                    >
                        <v-icon v-if="isMaxDialog">mdi-window-restore</v-icon>
						<v-icon v-else>mdi-window-maximize</v-icon>
                    </v-btn>
					<v-btn
                        icon
                        @click="closeDialogUrl()"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <img
                    v-if="$root.isImage(dialogUrl.content)"
                    :src="$root.asset(dialogUrl.content)"
                    :style="{
                        width: '100%',
                        height: '100%',
                        right: '0',
                        bottom: '0',
                        backgroundColor: dialogUrl.backgroundColor
                    }"
                />
                <div v-else ref="embedHtmlContainer" id="iframe-container" :style="{backgroundColor: dialogUrl.backgroundColor, overflow: 'auto', height: '100%'}">
					<iframe
                        frameborder="0"
                        allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;camera;microphone;"
                        scrolling="0"
						id="iframe"
						:src="$root.asset(dialogUrl.content)"
                        allowfullscreen="allowfullscreen" 
						mozallowfullscreen="mozallowfullscreen" 
						msallowfullscreen="msallowfullscreen" 
						oallowfullscreen="oallowfullscreen" 
						webkitallowfullscreen="webkitallowfullscreen"
                    ></iframe>
                </div>
            </v-card>
        </v-dialog>

		<v-dialog
			v-model="dialogZoom.show"
			no-click-animation
			persistent
			style="overflow: hidden"
			fullscreen
		>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
			>
				<v-card-title class="headline">
					<v-spacer></v-spacer>
					<v-btn
						icon
						@click="dialogZoom.show = false; vchat.bottom = '15px';"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<iframe
					:class="isShow ? 'd-none' : ''"
					:style="{
						zIndex: 1,
						width: '100%',
						height: '93.5vh',
						position: 'absolute',
					}"
					frameborder="0"
					allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
					scrolling="0"
					:src="
						baseLocation +
						'/zoom.jsp?nickname=' +
						$store.state.principal.firstName + ' ' + $store.state.principal.lastName +
						'&email=' +
						$store.state.principal.email +
						'&meetingId=' +
						(dialogZoom.value.includes('pwd=') ? dialogZoom.value.substring(dialogZoom.value.indexOf('j/') + 2, dialogZoom.value.indexOf('?')) : dialogZoom.value.substring(dialogZoom.value.indexOf('j/') + 2, dialogZoom.value.length)) +
						'&role=' +
						0 +
						'&password=' +
						(dialogZoom.value.includes('pwd=') ? dialogZoom.value.substring(dialogZoom.value.indexOf('pwd=') + 4, dialogZoom.value.length) : 'null') +
						'&disablePreview=' + ((dialogZoom.disablePreview == null || dialogZoom.disablePreview === '') ? true : dialogZoom.disablePreview)
					"
					allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
				></iframe>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogTeams.show"
			no-click-animation
			persistent
			style="overflow: hidden"
			fullscreen
		>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
			>
				<v-card-title class="headline">
					<v-spacer></v-spacer>
					<v-btn
						icon
						@click="dialogTeams.show = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<iframe
					:class="isShow ? 'd-none' : ''"
					:style="{
						zIndex: 1,
						width: '100%',
						height: '93.5vh',
						position: 'absolute',
					}"
					frameborder="0"
					allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
					scrolling="0"
					:src="$root.getUrlTeamsWithLink(dialogTeams.value)"
					allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
				></iframe>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogTraining.show"
			v-if="dialogTraining.show"
			no-click-animation
			persistent
			style="overflow: hidden"
			:fullscreen="isMaxDialog"
		>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
			>
				<v-card-title class="headline">
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="isMaxDialog == false ? maximizeDialogUrl() : minimizeDialogUrl()"
                    >
                        <v-icon v-if="isMaxDialog">mdi-window-restore</v-icon>
						<v-icon v-else>mdi-window-maximize</v-icon>
                    </v-btn>
					<v-btn
                        icon
                        @click="dialogTraining.show = false; dialogTraining.value= ''"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
					<iframe
						style="border:1px solid #e0e0e0; position: absolute"
						width="100%"
						height="88%"
						:src=dialogTraining.value
						allow="camera;microphone"
						allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
					>
					</iframe>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogClinic.show"
			v-if="dialogClinic.show"
			no-click-animation
			persistent
			style="overflow: hidden"
			>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
				>
				<v-card-title class="headline">
					<v-spacer></v-spacer>
					<v-btn
						icon
						@click="dialogClinic.show = false; dialogClinic.value= ''"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
					<iframe
						style="border:1px solid #e0e0e0; position: absolute"
						width="100%"
						height="89%"
						:src=dialogClinic.value
						allow="camera;microphone"
						allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
					>
					</iframe>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogProtectRoom"
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
			content-class="col-sm-7 col-12 hide-box-shadow"
			style="overflow: hidden"
			overlay-color="black"
			overlay-opacity="1"
			max-width="500"
		>
			<v-form
				ref="formPasswordProtectRoom"
				v-model="validPasswordProtectRoom"
				@submit.prevent="checkPasswordProtectRoom"
			>
				<v-card
					style="height:600px; margin: auto; padding: 0px"
					:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
				>
					<v-card-title
						class="headline warning justify-center pa-12"
						primary-title
					>
						<v-icon color="white" size="120"
							>mdi-alert-circle-outline</v-icon
						>
					</v-card-title>

					<v-card-text class="pa-6" style="text-align: center">
						<span class="title">Warning</span>
						<br />
						<br />
						<p style="text-align: justify">
							The Room is password protected. Please enter the
							password.
						</p>
						<v-text-field
							v-model="passwordProtect"
							:rules="[
								(v) =>
									!!v || 'Password Protect Room is required',
							]"
							:type="passwordFieldType"
							:append-icon="
								passwordFieldType === 'password'
									? 'mdi-eye'
									: 'mdi-eye-off'
							"
							@click:append="switchVisibility"
							label="Password Protect Room"
							outlined
						></v-text-field>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="default" @click="goBack()">Cancel</v-btn>
						<v-btn
							:disabled="!validPasswordProtectRoom"
							color="primary"
							type="submit"
							>Confirm</v-btn
						>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<v-dialog
			v-model="productDialog.show"
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
			content-class="col-sm-7 col-12 hide-box-shadow"
			style="overflow: hidden"
		>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
			>
				<v-card-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="productDialog.show = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-container>
					<v-row dense>
						<v-card
							class="mb-4 mr-2 ml-2"
							width="100%"
							v-for="(product, idxProduct) in productDialog.content"
							:key="idxProduct"
						>
							<v-col class="pb-0" cols="12">
								<div
									class="d-flex flex-no-wrap justify-space-between"
								>
									<div>
										<v-card-title
											class="headline"
											v-text="product.name"
										></v-card-title>
										<v-card-text
											v-text="product.description"
										></v-card-text>
									</div>
									<v-avatar class="ma-3" size="125" tile>
										<v-img
											:src="$root.asset(product.image)"
											contain
										></v-img>
									</v-avatar>
								</div>
							</v-col>
							<v-col class="pt-0" cols="12">
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn
										class="ml-2 mt-5"
										color="secondary"
										:href="product.urlLink"
										target="_blank"
										>View Full Product Details</v-btn
									>
								</v-card-actions>
							</v-col>
						</v-card>
					</v-row>
				</v-container>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="linkTypeDialog.show"
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
            content-class="pa-0 col-12 hide-box-shadow"
			style="overflow: hidden"
			:fullscreen="isMaxDialog"
			max-width="1200"
			scrollable
		>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{backgroundColor: linkTypeDialog.transparent, width: isMobile ? '100% !important;' : '80% !important'}"
			>
				<v-card-title class="headline" :style="{backgroundColor: isMedspa ? '#faa534' : dialog.backgroundColor, color: isMedspa ? '#ffffff' : '#000000'}">
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="isMaxDialog == false ? maximizeDialogUrl() : minimizeDialogUrl()"
                    >
                        <v-icon v-if="isMaxDialog">mdi-window-restore</v-icon>
						<v-icon v-else>mdi-window-maximize</v-icon>
                    </v-btn>
					<v-btn
                        icon
                        @click="linkTypeDialog.show = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
				<v-card-text :style="{backgroundColor: linkTypeDialog.backgroundColor}">
					<span>
						<div v-html="linkTypeDialog.content"></div>
					</span>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="clinicBookDialog.show"
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
			content-class="col-sm-7 col-12 pa-0 hide-box-shadow"
			style="overflow: auto"
			@click="iframeControl('')"
		>
			<v-card rounded="0">
				<v-card-text>
					<v-flex row-wrap justify-center>
						<v-row align="center" justify="center">
							<v-col class="pa-0">
								<v-card flat>
									<v-card-title class="headline">
										{{ clinicBookDialog.title }}
										<v-spacer></v-spacer>
										<v-btn
											icon
											@click="
												((clinicBookDialog.show = false),
												(isSubmitted = false)),
													iframeControl('')
											"
										>
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-card-title>
									<v-divider></v-divider>
									<v-card-text
										class="pa-5"
										v-if="!isSubmitted"
									>
										<form @submit="clinicSubmitBook">
											<v-text-field
												ref="clinic_input_name"
												label="Name"
												v-model="clinic_input_name"
												:rules="[
													() =>
														!!clinic_input_name ||
														'Name is required',
												]"
												required
											></v-text-field>

											<v-text-field
												ref="clinic_input_email"
												label="Email"
												v-model="clinic_input_email"
												:rules="[
													(v) =>
														/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
															v
														) ||
														'E-mail is required and must be valid',
												]"
												required
											></v-text-field>

											<v-text-field
												ref="clinic_input_phone"
												label="Phone"
												type="number"
												v-model="clinic_input_phone"
												:rules="[
													() =>
														!!clinic_input_phone ||
														'Phone is required',
												]"
												required
											></v-text-field>

											<v-textarea
												ref="clinic_input_req"
												label="Note"
												v-model="clinic_input_req"
												:rules="[
													() =>
														!!clinic_input_req ||
														'Requirement is required',
												]"
												required
											></v-textarea>
											<p></p>

											<v-btn
												class="green darken-1"
												type="submit"
												dark
												>{{ clinicBookDialog.name }}</v-btn
											>
										</form>
									</v-card-text>
									<v-card-text v-else>
										<h2
											class="black--text text--lighten-1"
										>
											{{ clinicBookResponse }}
										</h2>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-flex>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="clinicConsultationDialog.show"
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
			content-class="col-sm-7 col-12 hide-box-shadow"
			style="overflow: hidden"
			@click="iframeControl('')"
		>
			<v-row align="center" justify="center">
				<v-col cols="8">
					<v-card
						style="height:600px; margin: auto; padding: 0px"
						:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
					>
						<v-card-title class="headline">
							Please enter your consultation password below
							<v-spacer></v-spacer>
							<v-btn
								icon
								@click="
									((clinicConsultationDialog.show = false),
									(isConsultationSubmitted = false)),
										iframeControl('')
								"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text
							class="pa-5"
							v-if="!isConsultationSubmitted"
						>
							<h3 class="black--text text--lighten-1">
								You will then automatically join the Zoom
								consultation meeting. If you have not yet booked
								a consultation, please click
								<a
									@click="
										clinicConsultationDialog.show = false;
										clinicBookDialog.show = true;
									"
									sytle="color:red"
									>here</a
								>
								to request one now.
							</h3>
							<p></p>

							<h3 class="black--text text--lighten-1">Email :</h3>
							<v-text-field
								placeholder="email..."
								v-model="consulEmail"
							>
								<p></p>
							</v-text-field>

							<h3 class="black--text text--lighten-1">
								Password :
							</h3>
							<v-text-field
								:type="passwordFieldType"
								placeholder="password..."
								v-model="password"
								:append-icon="
									this.passwordFieldType === 'password'
										? 'mdi-eye'
										: 'mdi-eye-off'
								"
								@click:append="switchVisibility"
							></v-text-field>
							<button type="password" @click="switchVisibility">
								show / hide
							</button>
							<p></p>

							<v-btn
								class="green darken-1"
								type="button"
								@click="clinicConsultation"
								dark
								>Attend Consultation</v-btn
							>
						</v-card-text>
						<v-card-text v-else>
							<h2 class="black--text text--lighten-1">
								{{ clinicBookResponse }}
							</h2>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-dialog>

		<v-dialog
			v-model="dialogImageSlider.show"
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
            content-class="pa-0 col-12 hide-box-shadow"
		>
			<v-card
				style="height:100%; margin: auto; padding: 0px"
				:style="{backgroundColor: dialogImageSlider.transparent, width: isMobile ? '100% !important;' : '70% !important'}"
			>
				<v-card-title class="headline" :style="{backgroundColor: dialogImageSlider.backgroundColor}">
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogImageSlider.show = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text
					:style="{
						maxHeight: '76vh !important',
						overflowY: 'auto',
						backgroundColor: dialogImageSlider.backgroundColor
					}"
				>
					<v-row justify="center" >
						<v-col
							v-for="(item, index) in dialogImageSlider.images"
							:key="index"
							class="d-flex child-flex col-sm-2 col-6"
						>
							<v-hover v-slot="{ hover }">
								<v-card :elevation="hover ? 12 : 2">
									<v-img
										:src="!item.endsWith('.pdf') ? $root.asset(item) : $root.asset(item).replace('.pdf', '.jpg')"
										:lazy-src="!item.endsWith('.pdf') ? $root.asset(item) : $root.asset(item).replace('.pdf', '.jpg')"
										aspect-ratio="1"
										class="grey lighten-2"
									>
										<template v-slot:placeholder>
											<v-row
												class="fill-height ma-0"
												align="center"
												justify="center"
											>
												<v-progress-circular
													indeterminate
													color="grey lighten-5"
												></v-progress-circular>
											</v-row>
										</template>
										<div
											@click="
												(dialogCarousel = Object.assign(
													{},
													dialogImageSlider
												)),
													(dialogCarousel.open = index),
													sendToGA(dialogCarousel)
											"
											:class="hover ? 'd-flex' : 'd-none'"
											class="justify-center align-center"
											style="
												height: 100%;
												background-color: rgba(
													0,
													0,
													0,
													0.5
												);
												cursor: pointer;
											"
										>
											<v-icon large dark>
												mdi-magnify-plus
											</v-icon>
										</div>
									</v-img>
								</v-card>
							</v-hover>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogCarousel.show"
			no-click-animation
			persistent
			content-class="col-12 hide-box-shadow"
			fullscreen
		>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
			>
				<v-card-title class="headline">
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogCarousel.show = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-carousel
						v-model="dialogCarousel.open"
						hide-delimiters
						class="custom-slider"
						height="89vh"
						@change="sendToGA(dialogCarousel)"
					>
						<v-carousel-item
							class="text-center"
							v-for="(item, index) in dialogCarousel.images"
							:key="index"
							reverse-transition="fade"
							transition="fade"
						>
							<div  v-if="!item.endsWith('.pdf')"
								:style="{
									backgroundImage: 'url(' + $root.asset(item).replace(/\\/g,'/').replace(/ /g, '%20') + ')',
									backgroundRepeat: 'no-repeat',
									backgroundSize: 'contain !important',
									backgroundPosition: 'center',
									height: '100%',
									width: '100%'
								}"
							>
							</div>
							<iframe v-else
								frameborder="0"
								allow="autoplay; encrypted-media;camera;microphone"
								scrolling="0"
								width="100%"
								class="iframe-size"
								:src="$root.asset(item)"
								allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
								style="height:100%"
							></iframe>
						</v-carousel-item>
					</v-carousel>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogFileUpload.show"
			no-click-animation
			persistent
			content-class="col-sm-4 col-12 hide-box-shadow "
		>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
			>
				<v-card-title class="headline">
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogFileUpload.show = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text
					style="max-height: 76vh !important; overflow-y: auto"
				>
					<v-row style="margin: 0" justify="end">
						<v-col>
							<v-file-input
								v-model="attachment1"
								label="File upload"
								:rules="[
									(v) => !!v || 'File Upload is required',
								]"
							></v-file-input>
						</v-col>
					</v-row>
					<v-row
						class="text-right"
						style="margin: 0"
						justify="end"
					>
						<v-col cols="12" sm="8">
							<v-btn
								:disabled="!validFileUpload"
								color="primary"
								type="submit"
								@click="upload(dialogFileUpload)"
								>upload</v-btn
							>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
				v-model="dialogFileDownload.show"
				no-click-animation
				persistent
				content-class="col-sm-4 col-12 hide-box-shadow"
			>
			<v-card
				style="height:600px; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '80% !important'}"
			>
				<v-card-title class="headline">
					<h3>Confirm File Download</h3>
					<v-spacer></v-spacer>
					<v-btn
						icon
						@click="closeDialogFileDownload"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="text-center" style="max-height: 76vh !important; overflow-y: auto;">
					<v-row
						v-if="dialogFileDownload.link != null && dialogFileDownload.link.toLowerCase().match('^.*\.(jpg|jpeg|png|mp4|pdf)$')"
						style="max-height:720px;">
						<v-col style="height:320px; width:100%; display: block; margin-left:15%; margin-right:15%">
							<iframe style="height:100%; width:100%;"
								frameborder="0"
								scrolling="0"
								allowtransparency = "1"
								allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
								:src="dialogFileDownload.link">
							</iframe>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-btn
							@click="closeDialogFileDownload"
							>Cancel</v-btn>

							<v-btn
							style="margin-left:12px"
							class="green darken-1"
							dark
							@click="executeDownloadDialog"
							>Download</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>


		<v-dialog
			v-model="isPosterShow"
			v-if="isPosterShow"
			content-class="pa-0 col-9 hide-box-shadow"
		>
			<v-card
				style="background-color: #000000bb; height:100%; margin: auto; padding: 0px"
				:style="{ width: isMobile ? '100% !important;' : '100% !important'}"
			>
				<v-btn icon color="white" @click="isPosterShow = false" style="position: absolute; right: 0px">
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<v-card-title class="justify-center">
					<span class="headline" style="color: white">{{ entityPreview.name }}</span> hello world
				</v-card-title>

				<v-card-text>
					<div
						style="margin: 10px; margin: auto; border-top-left-radius: 12px; border-top-right-radius: 12px; padding: 5px"
						:style="{ backgroundColor: entityPreview.backgroundColor}"
					>
						<v-row v-for="(item, index) in entityPreview.posterDataList" :key="index" style="margin: 5px; padding: 0px">
							<v-col v-for="(item1, index1) in item" :key="index1" :cols="12 / item.length" style="padding: 1px">
								<v-btn
									v-if="item1.type == 'URL FIELD'"
									width="100%"
									:color="item1.backgroundColor"
									:style="{ color: item1.fontColor }"
									@click="openNewTab(item1.value)"
								>
									{{ item1.label }}
								</v-btn>
								<v-btn
									v-else-if="item1.type == 'FILE DOWNLOAD'"
									width="100%"
									:color="item1.backgroundColor"
									:style="{ color: item1.fontColor }"
									@click="download(item1.value)"
								>
									{{ item1.label }}
									<v-icon :color="item1.iconColor" medium>mdi-download</v-icon>
								</v-btn>
								<div
									v-else-if="item1.type == 'TEXT'"
									v-html="item1.value"
									:style="{
										backgroundColor: item1.backgroundColor,
										border: '1px solid ' + item1.backgroundColor
									}"
									style="border: 1px solid black; padding: 10px 10px 0px 10px"
								></div>
								<div  v-else-if="item1.type == 'GALLERY'" class="d-flex justify-center align-center">
									<v-carousel hide-delimiters height="368" style="max-width:555px">
										<v-carousel-item
											v-for="(image, idxImage) in item1.images"
											class="galley_poster"
											:key="idxImage"
											:src="$root.asset(image)"
											reverse-transition="fade"
											transition="fade"
											@click="showDialogCarousel(item1.images, idxImage)"
										>
										</v-carousel-item>
									</v-carousel>
								</div>
								<iframe
									v-else-if="item1.type == 'VIDEO'"
									id="video_poster"
									:src="$root.asset(item1.value)"
									frameborder="0"
									allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'"
									scrolling="0"
									width="100%"
									height="300px"
									allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
								>
								</iframe>
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-main>
</template>

<style>
.custom-carousel .v-window__prev,
.custom-carousel .v-window__next {
  background: linear-gradient(to right, #09A0E9, #21539F) !important;
}
</style>

<style>
#room > .v-main__wrap {
	overflow-x: auto;
}

.poster_search > div > div > div > input {
	color: white !important;
}
.poster_search > div > div > div >  input::placeholder {
	color: white !important;
}
.poster_search > div > div > div > div > i {
	color: white !important;
}
</style>

<style scoped>

.v-main {
	background-color: black !important;
}
.room-link {
	cursor: pointer;
	position: absolute;
}
.scrollable {
	overflow-y: auto;
	overflow-x: hidden;
	height: 300px;
}
#iframe-container {
	position: relative;
	width: 100%;
	height: 0;
	padding-bottom: 56.25%;
}
#iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
#iframeZoom {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
#v-card-title-zoom-embed {
    padding: 0px;
}

/* Let's get this party started */
::-webkit-scrollbar {
	height: 7px;
	width: 7px;
	background: rgba(65, 109, 116, 1);
}

/* Track */
::-webkit-scrollbar-track {
	-webkit-border-radius: 10px;
	border-radius: 10px;
	background: rgba(0, 0, 0, 0.7);
}

/* Handle */
::-webkit-scrollbar-thumb {
	-webkit-border-radius: 10px;
	border-radius: 10px;
	background: rgba(65, 109, 116, 1);
}


</style>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
import axios from "axios";
import {eventBus} from '../../main';
import Vimeo from "@vimeo/player";

export default {
	props: ["tenantSlug", "experienceSlug", "vchat", "tmpVChat"],
	components: {
	},
	data() {
		return {
			entity: { dataMap: {} },
			experience: {},
			boothList: [],
			boothLogo: null,
			index: -1,
			intervalRotatingLogo: null,
			isShow: false,
			dialog: { show: false, title: null, content: null },
			dialogUrl: { show: false, title: null, content: null },
			dialogZoom: { show: false, value: "" },
			dialogTeams: { show: false, value: "" },
			dialogTraining: { show: false, value: "" },
			dialogClinic: { show: false, value: "" },
			productDialog: { show: false, content: null },
			baseLocation: axios.defaults.baseURL,
			linkTypeDialog: { show: false, content: null },
			dialogProtectRoom: false,
			clinicBookDialog: { show: false, bookingType: 'Send_Email', recipientEmail: null , title: "", name:"Submit"},
			clinicConsultationDialog: { show: false },
			clinicBookResponse: "",
			isSubmitted: false,
			isConsultationSubmitted: false,
			password: "",
			consulEmail: "",
			passwordFieldType: "password",
			clinic_input_name: "",
			clinic_input_email: "",
			clinic_input_phone: "",
			clinic_input_req: "",
			passwordProtect: null,
			validPasswordProtectRoom: true,
			boothSelectedList: [],
			passwordProtectRoomFieldType: "password",
			dialogImageSlider: { show: false, images: [] },
			dialogCarousel: { show: false, images: [] },
			dialogFileUpload: { show: false},
			dialogFileDownload: { show: false, link: null, fileName: null },
			validFileUpload: true,
			attachment1: null,
			search: "",
			isShowZoomEmbed: true,
			layerMode: false,
			bannerRotatingMarginTop: "0px",
			posterOriList: [],
			posterList: [],
			posterPage: 0,
			idPosterList:[],
			searchPoster: "",
			isPosterShow: false,
			posterPopupWidth: "1200px",
			entityPreview: {
				backgroundColor: "#e0dede",
				posterDataList: []
			},
			footerMarginTop: "",
			btnSkipLeft: "calc(100vw - 100px)",
			tmpSlug: "",
			isTheFirstLoad : true,
			transitionYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1},
			backgroundYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true},
			transitionVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false},
			videoTransition: "",
			transitionThumbnail: "",
			divFooterWidth: 'none',
			footerWidth: 'none',
			backgroundIsNotYoutubeOrVimeo: false,
			showBtnTransition: false,
			vTrainingUserGUID: "",
			indexBack: -1,
			attrs: null,
			on: null,
			isMobile: false,
			userModules: [],
			isMaxDialog: false,
			isMedspa: false,
			linktoEntity:null,
			
			posterByPageStyle_default: {
				margin: '10px',
				width: '555px',
				borderTopLeftRadius: '12px',
				borderTopRightRadius: '12px',
				padding: '5px',
			},
			posterByPageStyle_theaestheticnexus: {
				margin: '10px',
				width: '755px',
				borderTopLeftRadius: '12px',
				borderTopRightRadius: '12px',
				padding: '5px',
			},
			posterNxtPrev_BtnStyle_default: {
				textTransform: 'none',
				background: '#99999B',
				borderRadius: '5px',
				color: '#fff',
				boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
				fontSize: 'calc(13px + 0.2vw)'
            },
            posterNxtPrev_BtnStyle_theaestheticnexus: {
				textTransform: 'none',
				background: 'linear-gradient(to right, #09A0E9, #21539F)',
				borderRadius: '5px',
				color: '#fff',
				boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
				fontSize: 'calc(13px + 0.2vw)'
            },
		};
	},
	computed: {
		structureSlug() {
			return this.$route.params.structureSlug;
		},
		filteredBoothSelectedList() {
			return this.boothSelectedList.filter((item) => {
				if (!this.search) {
					return this.boothSelectedList;
				} else {
					return item.name
						.toLowerCase()
						.includes(this.search.toLowerCase());
				}
			});
		},
		posterByPageStyle() {
            return this.$router.app._route.params.tenantSlug === 'theaestheticnexus' ? this.posterByPageStyle_theaestheticnexus : this.posterByPageStyle_default;
        },
		posterNxtPrev_BtnStyle() {
            return this.$router.app._route.params.tenantSlug === 'theaestheticnexus' ? 
			this.posterNxtPrev_BtnStyle_theaestheticnexus : this.posterNxtPrev_BtnStyle_default;
        },
		posterCarousel_BtnStyle() {
            return this.$router.app._route.params.tenantSlug === 'theaestheticnexus' ? 
			'custom-carousel' : '';
        },
	},
	watch: {
		structureSlug: function () {
			this.isShow = false;
			this.findStructure();
		},
		"$store.state.isFitToWidth": function() {
			this.calcScale();
		}
	},
	mounted() {
		this.onResize();
		window.addEventListener("resize", this.onResize, { passive: true });
		this.getUserGuid();
		this.vchat.isTransition = true;
		this.getExperience();
		window.onresize = () => {
			this.calcScale();
		};

		// setTimeout(() => {
		// 	this.calcScale();
		// }, 15000);

	},
	methods: {
		goToPreviousPage() {
			const totalPages = Math.ceil(this.posterList.length / 4);
			this.posterPage = this.posterPage === 0 ? totalPages - 1 : this.posterPage - 1;
		},

		goToNextPage() {
			const totalPages = Math.ceil(this.posterList.length / 4);
			this.posterPage = this.posterPage === totalPages - 1 ? 0 : this.posterPage + 1;
		},

		onResize() {
			this.isMobile = window.matchMedia("only screen and (max-width: 599px)").matches;
		},
		getUserGuid() {
			axios
				.get("/system/vTraining/user/guid")
				.then(async (response) => {
					if (response.data) {
						this.vTrainingUserGUID = response.data;

						axios
						.post("/system/user/module", {userGuid: this.vTrainingUserGUID} )
						.then(async (response) => {
							if (response.data) {
								this.userModules = response.data;
							}
						})
					}
				})
		},
		switchVisibility() {
			this.passwordFieldType =
				this.passwordFieldType === "password" ? "text" : "password";
		},
		findStructure() {
			if (this.$root.showLiveSupport) {
				this.$root.setCurrentUrlLiveSupport(this.$router.currentRoute.path);
			}
			axios
				.get("/system/structure/slug?slug=" + this.structureSlug)
				.then(async (response) => {
					this.entity = response.data;
					// console.log(this.entity.linkToDataList);
					let isThereTraining = false;
					for (let item of this.entity.linkToDataList) {
						if (item.type === 'Button') {
							if(isNaN(item.borderRadius)) {
								item.borderRadius = item.borderRadius === "rounded" ? "28px" : "0px";
							}  else {
								item.borderRadius = item.borderRadius + 'px';
							}
							if (!isNaN(item.borderWidth)) {
								item.borderWidth = item.borderWidth + 'px';
							}
						} else if (item.type === 'Training' || item.type === 'Completed_Training') {
							if (item.type === 'Training') {
								// check for categories that have been deleted
								axios.get("/system/vTraining/category/list").then((response) => {
									if (response.data) {
										let categoryList = [];
										let trainingCategoryList = response.data;
                                        console.log(item);
                                        if (trainingCategoryList) {
                                            for (let category of trainingCategoryList) {
                                                if (item.categories.includes(category.categoryId)) {
                                                    categoryList.push(category.categoryId);
                                                }
										    }
                                        }

										item.categories = categoryList;
									}
								});

								if (!item.value) {
									item.value = "\u003cp\u003e\u003cspan style\u003d\"color: #ecf0f1;\"\u003eShow Training\u003c/span\u003e\u003c/p\u003e";
									item.backgroundColor = "#003366";
									item.borderColor = "#00000000";
									item.borderWidth = "0";
									item.borderRadius = "3";
								}
							}

							if (item.target == 'Embed') {
								this.indexBack--;
							}
							isThereTraining = true;
						}
					}
					// Check if large asset is exist and use it
					let vm = this
					this.$root.isImageExist(this.$root.largeAsset(this.entity.background), function(status) {
						if (status) {
							vm.entity.background = vm.$root.largeAsset(vm.entity.background);
						}
					});

					if (this.$root.isImage(this.entity.background) || this.$root.isVideo(this.entity.background)){
							this.backgroundIsNotYoutubeOrVimeo = true;
					}

					if (!this.entity.dataMap.introTransition) {
						this.entity.dataMap.introTransition = {
							autoplay: true,
							sound: false
						}
					}

					if (this.$store.state.showVideoTransition) {
						if (this.$root.isVideo(this.entity.introTransition)) {
							this.tmpSlug = ""
							this.isShow = true;
							let vm = this;
							var video = document.getElementById("videoTransition");
							video.src = this.entity.introTransition;
							video.addEventListener('loadeddata', () => {
								if(video.readyState === 4) {
									this.calcScale();
									document.getElementsByClassName("v-main__wrap")[0].scrollLeft = (video.getBoundingClientRect().width-window.innerWidth)/2;
								}
							});

							if (this.entity.dataMap.introTransition.autoplay) {
								video.play();
							} else {
								this.showBtnTransition = true;
							}
							video.muted = !this.entity.dataMap.introTransition.sound;

							video.addEventListener('playing', () => {
								this.showBtnTransition = false;
							});
							video.addEventListener('pause', () => {
								this.showBtnTransition = true;
							});
							video.onended = function () {
								vm.isShow = false;
								vm.calcScale();
							};
						} else if (this.$root.isYoutubeUrl(this.entity.introTransition)) {
							this.tmpSlug = ""
							this.isShow = true;
							this.videoTransition = this.$root.getYoutubeId(this.entity.introTransition, null);
							this.transitionThumbnail = "https://img.youtube.com/vi/" + this.videoTransition + "/maxresdefault.jpg";

							this.transitionYoutubeParams.mute = !this.entity.dataMap.introTransition.sound ? 1 : 0;
							this.transitionYoutubeParams.autoplay = this.entity.dataMap.introTransition.autoplay ? 1 : 0;
							if (!this.entity.dataMap.introTransition.autoplay && (this.entity.dataMap.introTransition.autoplay && this.entity.dataMap.introTransition.sound)) {
								this.showBtnTransition = true;
							}

							this.$nextTick(() => {
								if (this.$vuetify.breakpoint.mobile && this.entity.dataMap.introTransition.autoplay){
									this.$refs.backgroundTransition.player.playVideo();
								}
							});
						} else if (this.$root.isVimeoUrl(this.entity.introTransition)) {
							this.tmpSlug = ""
							this.isShow = true;
							this.videoTransition = this.entity.introTransition;

							axios
								.get("/system/public/vimeo/thumbnail?vimeoUrl=" + this.videoTransition)
								.then(async (response) => {
									if (response.data) {
										this.transitionThumbnail = response.data;
									}
								})

							this.transitionVimeoParams.muted = !this.entity.dataMap.introTransition.sound;
							this.transitionVimeoParams.autoplay = this.entity.dataMap.introTransition.autoplay;
							if (!this.entity.dataMap.introTransition.autoplay) {
								this.showBtnTransition = true;
							}
						} else {
							this.vchat.isTransition = false;
						}
					} else {
						this.vchat.isTransition = false;
					}

					if (
						this.entity.dataMap &&
						this.entity.dataMap.boothSelected
					) {
						this.getBoothSelectedList(
							this.entity.dataMap.boothSelected
						);
					} else {
						// to clean if user also exhibition previously
						this.boothSelectedList = [];
					}

					if (isThereTraining && !this.entity.dataMap.vTrainingUserGUID) {
						axios
							.get("/system/vTraining/user/guid")
							.then(async (response) => {
								if (response.data) {
									this.vTrainingUserGUID = response.data;
								}
							})
					}

					if (await this.entity.dataMap.isPasswordProtectRoom) {
						this.dialogProtectRoom = true;
						this.passwordProtect = null;
					}

					this.$nextTick(() => {
						if (this.$root.isVideo(this.entity.background)) {
							var video = document.getElementById("video");
							video.load();
							let vm = this;
							video.addEventListener('loadeddata', () => {
								this.bannerRotatingMarginTop = this.$refs.roomView.clientHeight + "px";
								if(video.readyState === 4) {
									vm.calcScale();
								}
							});
						}
						if (this.entity.dataMap.isExhibitionHall && this.entity.dataMap.bannerRotatingVideo) {
							if (!this.experience.dataMap.fitToHeight) {
								this.bannerRotatingMarginTop = this.$refs.roomView.clientHeight + "px";
							} else {
								let navHeight = document.getElementById("navigation").clientHeight;
								this.bannerRotatingMarginTop = "calc(100vh - " + navHeight + "px)";
							}
						}
					});

					let activityLog = {
						type: "Visit_room",
						dataMap: { structureId: this.entity.id, room: this.entity.name ?? '' },
					};
					
					this.$root.saveActivityLog(activityLog);

					if (this.entity.dataMap.exhibitorsIndex) {
						this.boothList = this.entity.linkToDataList.filter(
							(item) => item.type === "Booth"
						);

						this.boothList.sort((a, b) =>
							a.name > b.name ? 1 : -1
						);

						this.intervalRotatingLogo = setInterval(
							() =>
								this.entity.dataMap.exhibitorsIndex &&
								!this.entity.dataMap.bannerRotatingVideo
									? this.setBoothLogo()
									: this.clearAllInterval(),
							5000
						);
					}

					if (this.entity.dataMap.isPosterRoom) {
						this.listPoster();
						this.idPosterList = this.entity.dataMap.posterSelected;
					}
				})
				.catch(() => {});
		},
		getBoothSelectedList(boothList) {
			axios
				.post("/system/booth/list", {
					experienceId: this.experienceId,
				})
				.then((response) => {
					this.boothSelectedList = [];
					for (let i = 0; i < boothList.length; i++) {
						let list = Object.assign([], response.data);
						for (let data of list) {
							if (boothList[i] == data.id) {
								this.boothSelectedList.push(data);
							}
						}
					}
				});
			this.dialogBoothOrder = true;
		},
		getExperience() {
			axios
				.get("/system/experience/find")
				.then((response) => {
					this.experience = response.data;
					this.layerMode = this.experience.layerMode;
					this.findStructure();
					this.calcScale();
				})
				.catch(() => {});
		},
		setBoothLogo() {
			if (this.index < this.entity.linkToDataList.length - 1) {
				this.index++;
			} else {
				this.index = 0;
			}
			this.boothLogo =
				this.entity.linkToDataList[this.index].type === "Booth"
					? this.entity.linkToDataList[this.index].logo
					: "";
		},
		clearAllInterval() {
			for (let id = 0; id < this.intervalRotatingLogo; id++) {
				clearInterval(id);
			}
		},
		sendToGA(entity) {
			let name = this.$store.state.principal.firstName + " " + this.$store.state.principal.lastName;
			this.$gtag.event('linkTo_event', {
				event_category: 'LinkTo',
				event_label: window.location,
				LinkToId: entity.id,
				LinkToLabel: entity.label ? entity.label : "-",
				LinkToType: entity.type,
				UserId: this.$store.state.principal.id,
				Name: name,
				RoomName: this.structureSlug,
				ExperienceId: this.experience.id,
				ExperienceName: this.experience.name,
				room: this.entity.name ?? ''
			});
		},
		linkTo(entity) {
			if (entity.type === "Structure") {
				this.sendToGA(entity);
				axios
					.get("/system/structure?id=" + entity.value)
					.then((response) => {
						if (!this.entity.dataMap.outroTransition) {
							this.entity.dataMap.outroTransition = {
								autoplay: true,
								sound: false
							}
						}

						this.showBtnTransition = false;
						if (this.$store.state.showVideoTransition && this.$root.isVideo(this.entity.outroTransition)) {
							this.vchat.isTransition = true;
							this.tmpSlug = response.data.slug;
							this.isShow = true;
							var video = document.getElementById("videoTransition");
							video.src = this.entity.outroTransition;
							video.addEventListener('loadeddata', () => {
								if(video.readyState === 4) {
									document.getElementsByClassName("v-main__wrap")[0].scrollLeft = (video.getBoundingClientRect().width-window.innerWidth)/2;
								}
							});
							if (this.entity.dataMap.outroTransition.autoplay) {
								video.play();
							} else {
								this.showBtnTransition = true;
							}
							video.muted = !this.entity.dataMap.outroTransition.sound;

							video.addEventListener('playing', () => {
								this.showBtnTransition = false;
							});
							video.addEventListener('pause', () => {
								this.showBtnTransition = true;
							});

							let vm = this;
							video.onended = function () {
								vm.entity.background = null;
								vm.entity.introTransition = null;
								vm.entity.outroTransition = null;
								vm.entity.linkToDataList = [];
								vm.$router.push(
									"/" +
										vm.tenantSlug +
										"/" +
										vm.experienceSlug +
										"/hall/" +
										response.data.slug
								);
							};
						} else if (this.$store.state.showVideoTransition && this.$root.isYoutubeUrl(this.entity.outroTransition)) {
							this.vchat.isTransition = true;
							this.tmpSlug = response.data.slug;
							this.isShow = true;
							this.videoTransition = this.$root.getYoutubeId(this.entity.outroTransition, null);
							this.transitionThumbnail = "https://img.youtube.com/vi/" + this.videoTransition + "/maxresdefault.jpg";

							this.transitionYoutubeParams.mute = !this.entity.dataMap.outroTransition.sound ? 1 : 0;
							this.transitionYoutubeParams.autoplay = this.entity.dataMap.outroTransition.autoplay ? 1 : 0;
							if (!this.entity.dataMap.outroTransition.autoplay && !this.showBtnTransition) {
								this.showBtnTransition = true;
							}

							this.$nextTick(() => {
								if (this.$vuetify.breakpoint.mobile && this.entity.dataMap.outroTransition.autoplay){
									this.$refs.backgroundTransition.player.playVideo();
								}
							});
						} else if (this.$store.state.showVideoTransition && this.$root.isVimeoUrl(this.entity.outroTransition)) {
							this.vchat.isTransition = true;
							this.tmpSlug = response.data.slug;
							this.isShow = true;
							this.videoTransition = this.entity.outroTransition;

							axios
								.get("/system/public/vimeo/thumbnail?vimeoUrl=" + this.videoTransition)
								.then(async (response) => {
									if (response.data) {
										this.transitionThumbnail = response.data;
									}
								})
							this.transitionVimeoParams.muted = !this.entity.dataMap.outroTransition.sound;
							this.transitionVimeoParams.autoplay = this.entity.dataMap.outroTransition.autoplay;

							if (!this.entity.dataMap.outroTransition.autoplay) {
								this.showBtnTransition = true;
							} else {
								this.$refs.backgroundTransitionVimeo.play();
							}
						} else {
							this.$router.push(
								"/" +
									this.tenantSlug +
									"/" +
									this.experienceSlug +
									"/hall/" +
									response.data.slug
							);
						}
					});
			} else if (entity.type === "Booth") {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/booth/" +
						entity.value
				);
			} else if (entity.type === "Auditorium") {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/auditorium/" +
						entity.value
				);
			} else if (entity.type === "Track") {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/auditorium/" +
						entity.subType +
						"/track/" +
						entity.value
				);
			} else if (["Leaderboard"].includes(entity.type)) {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/" +
						entity.type.toLowerCase()
				);
			} else if (entity.type === "Chat") {
				//call java API to send entity.selectedChatRoom to be saved on experienceuser
				axios.post("/system/user/chatRoom/add",
				{ userId: this.$store.state.principal.id, chatRoom : entity.rooms })
				.then(() => {

					// open bubble chat
					eventBus.$emit('openbubblechat', entity.rooms[0]);
				});

			} else if (entity.type === "Private_Chat") {
				//call java API to send entity.selectedChatRoom to be saved on experienceuser
				var privateRoom = [];
				privateRoom.push(entity.privateChatRoom);
				axios.post("/system/user/chatRoom/add",
				{ userId: this.$store.state.principal.id, chatRoom : privateRoom })
				.then(() => {

					// open bubble chat
					eventBus.$emit('openbubblechat', privateRoom);
				});

			} else if (entity.type === "Chat_Lounge") {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/chat"
				);


			} else if (entity.type === "Book_Consultation") {
				this.clinicBookDialog.show = true;
				this.clinicBookDialog.title = entity.title;
				if(entity.name != null){
					this.clinicBookDialog.name = entity.name;
				}
				if(entity.bookingType){
					this.clinicBookDialog.bookingType = entity.bookingType;
					this.clinicBookDialog.recipientEmail = entity.email;
				}
			} else if (entity.type === "Attend_Consultation") {
				this.clinicConsultationDialog.show = true;
			} else if (entity.type === "URL") {
				this.sendToGA(entity);
				if (entity.target === "New Tab") {
					let activityLog = {
						type: "Room_url_new_tab",
						dataMap: {
							structureId: this.entity.id,
							videoId: entity.id,
							value: entity.value,
							room: this.entity.name ?? '',
						},
					};
					this.$root.saveActivityLog(activityLog);
					window.open(entity.value, "_blank");
				} else if (entity.target === "Current Tab") {
					let activityLog = {
						type: "Room_url_current_tab",
						dataMap: {
							structureId: this.entity.id,
							videoId: entity.id,
							value: entity.value,
							room: this.entity.name ?? '',
						},
					};
					this.$root.saveActivityLog(activityLog);
					window.open(entity.value, "_self");
				} else if (entity.target === "Dialog") {
					this.dialogUrl.show = true;
                    this.dialogUrl.title = entity.title;

					var validSrc = "";

					if (entity.value.includes('medspabizuniversity')) {

						if (entity.value.includes('/training?')) {
							validSrc = entity.value + '&frame='+this.$store.state.principal.medspaToken
						} else {
							validSrc = entity.value + '?frame='+this.$store.state.principal.medspaToken
						}
						this.isMedspa = true;
					} else {
						validSrc = entity.value;
						this.isMedspa = false;
					}

					this.dialogUrl.content = validSrc;
					this.linktoEntity = entity;

					this.iframeControl(validSrc);

					this.saveLogs().then(() => {
						console.log("Logs saved successfully.");
									
						this.intervalId = setInterval(() => {
							if(this.linktoEntity != null){
								if(this.linktoEntity.type=="URL" && this.linktoEntity.target == "Dialog"){
									this.saveLogs().then(() => {
										console.log("Logs saved successfully.");
									});
								}
							}
						}, 300000);
					});

				}
			} else if (entity.type === "Product") {
				this.productDialog.show = true;
				this.productDialog.content = JSON.parse(entity.value);
			} else if (entity.type == "Dialog") {
				this.sendToGA(entity);
				this.linkTypeDialog.show = true;
				this.linkTypeDialog.content = entity.value;
				this.linkTypeDialog.backgroundColor = entity.backgroundColor;
				this.linkTypeDialog.transparent = entity.backgroundColor == '#FFFFFF00' ? '#FFFFFFFF' : '#00000000';
			} else if (entity.type === "Embed_HTML") {
				if (entity.target === "Dialog") {
					this.sendToGA(entity);
					this.dialog.contentType = entity.type;
					this.dialog.content = entity.valueRender ? entity.valueRender : entity.value;
					this.dialog.title = entity.title;
					this.dialog.show = true;
					this.dialog.backgroundColor = entity.backgroundColor;
					this.dialog.transparent = entity.backgroundColor == '#FFFFFF00' ? '#FFFFFFFF' : '#00000000';

					let embed = document.getElementById('embedHtml');
					if (embed != null) {
						embed.innerHTML = entity.valueRender ? entity.valueRender : entity.value;
					}

					// Scroll to center for smaller screen
					let iframeContainer = this.$refs.embedHtmlContainer;
					this.$nextTick(() => {
						// Child: Div hotspot_embed_html -> Iframe value with defined width
						if(iframeContainer.children[0].children){
							let iframe = iframeContainer.children[0].children[0];
							let offset = iframe.clientWidth - iframeContainer.clientWidth;
							if(offset > 0){
								iframeContainer.scrollLeft = offset / 2;
							}
						}
					});
				}
			} else if (entity.type === "Zoom") {
				if (entity.target === "Dialog") {
					this.sendToGA(entity);
					this.dialogZoom.value = entity.value;
					this.vchat.bottom = "50px";
					this.dialogZoom.disablePreview = entity.disablePreview;
					this.dialogZoom.show = true;
				}
			} else if (entity.type === "Teams") {
				if (entity.target === "Dialog") {
					this.sendToGA(entity);
					this.dialogTeams.value = entity.value;
					this.dialogTeams.show = true;
				}
			} else if (entity.type === "Training" || entity.type === "Completed_Training") {
				if (entity.target === "Dialog") {
					this.showTrainingDialog(entity);
				}
			} else if (entity.type === "Training_Clinic_Admin") {
				if (entity.target === "Dialog") {
					this.showClinicDialog(entity);
				}
			}
			else if (entity.type == "Image_Slider") {
				this.dialogImageSlider.show = true;
				this.dialogImageSlider.type = entity.type;
				this.dialogImageSlider.id = entity.id;
				this.dialogImageSlider.label = entity.label;
				this.dialogImageSlider.images = entity.images;
				this.dialogImageSlider.backgroundColor = entity.backgroundColor;
				this.dialogImageSlider.transparent = entity.backgroundColor == '#FFFFFF00' ? '#FFFFFFFF' : '#00000000';
			} else if (entity.type == "File_Upload") {
				this.dialogFileUpload.show = true;
				this.dialogFileUpload.type = entity.type;
				this.dialogFileUpload.id = entity.id;
				this.dialogFileUpload.label = entity.label;
			} else if (entity.type == "Live_Support") {
				this.sendToGA(entity);
				this.$root.dialogLiveSupport(this.experience.dataMap.tenantName, this.experience.name);
			}
		},
		async saveLogs() {
			let entity = this.linktoEntity;
			let iframe = document.getElementById("iframe");
			let player = new Vimeo(iframe);

			let percentage = await this.getWatchedPercentage(player);
			let final_percentage = percentage+'%';

			let activityLog = {
				type: "Watch_video_in_room",
				dataMap: {
					structureId: this.entity.id,
					videoId: entity.id,
					value: this.dialogUrl.content,
					title: entity.title,
					room: this.entity.name ?? '',
					time: final_percentage,
				},
			};
			this.$root.saveActivityLog(activityLog);

		},
		async getWatchedPercentage(player) {
			return new Promise((resolve) => {
				player.getCurrentTime().then((currentTimeInSeconds) => {
					player.getDuration().then((duration) => {
						let percentageWatched = (currentTimeInSeconds / duration) * 100;
						percentageWatched = Math.round(percentageWatched);
						resolve(percentageWatched);
					});
				});
			});
		},
		iframeControl(value) {
			var iframe = document.getElementById("iframe");
			if (iframe != null) {
				iframe.src = this.$root.asset(value);
			}
			var frame = iframe.cloneNode();
			iframe.parentNode.replaceChild(frame, iframe);

			// handle close embed html type
			if (this.dialog.contentType === 'Embed_HTML') {
				let embed = document.getElementById('embedHtml');
				if (value == "" && embed != null) {
					embed.innerHTML = "";
				}
			}
		},
		clinicSubmitBook() {
			axios
				.post("/system/clinic/book/send", {
					name: this.clinic_input_name,
					email: this.clinic_input_email,
					phone: this.clinic_input_phone,
					req: this.clinic_input_req,
					slug: this.experienceSlug,
					recipientEmail : this.clinicBookDialog.recipientEmail
				})
				.then((response) => {
					this.isSubmitted = true;
					this.clinic_input_name = "";
					this.clinic_input_email = "";
					this.clinic_input_phone = "";
					this.clinic_input_req = "";
					this.clinicBookResponse = response.data;
				})
				.catch(() => {});
		},
		clinicConsultation() {
			axios
				.post("/system/clinic/consultation", {
					email: this.consulEmail,
					password: this.password,
					slug: this.experienceSlug,
				})
				.then((response) => {
					if (response.data != null) {
						this.clinicConsultationDialog.show = false;
						window.open(response.data.zoomLink, "_blank");
					} else {
						alert(
							"Incorrect! Please check your email account and consultation password that has been sent to your email."
						);
					}
				})
				.catch(() => {});
		},
		checkPasswordProtectRoom() {
			axios
				.post("/system/structure/checkpasswordprotectroom", {
					password: this.passwordProtect,
					id: this.entity.id,
				})
				.then((response) => {
					if (response.data) {
						this.dialogProtectRoom = false;
					}
				});
		},
		goBack() {
			this.$router.go(-1);
			this.entity.background = null;
			this.entity.outroTransition = null;
			this.dialogProtectRoom = false;
		},
		upload(entity) {
			let formData = new FormData();
			formData.append("experienceUserId", this.$store.state.principal.id);
			formData.append("experienceId", this.experience.id);
			formData.append("tenantId", this.experience.tenantId);
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios
				.post("/system/public/structure/linkto/fileUpload", formData)
				.then((response) => {
					if (response.data) {
						this.dialogFileUpload.show = false;
						this.attachment1 = "";
						this.sendToGA(entity);
					}
				})
				.catch(() => {});
		},
		clearSearch() {
			this.search = "";
		},
		calcScale() {
			var custom = document.getElementById("custom");
			var room = document.getElementById("room-view");
			var poster = document.getElementById("poster-view");
			let navHeight = document.getElementById("navigation").clientHeight;
			var scale = 1;
			this.footerWidth = 'none';

			if (document.body.clientWidth < 1280) {
				this.posterPopupWidth = "100%";
			}
			if (document.body.clientWidth >= 960 && !this.$vuetify.breakpoint.mobile) {
				this.btnSkipLeft = "calc(100vw - 100px)";
				if (room != null) {
					if (((!this.experience.dataMap || !this.experience.dataMap.fitToHeight) && this.isTheFirstLoad) || !this.$store.state.isFitToWidth) {
						room.style.transform = "scale(" + document.body.clientWidth / (1920 * 0.5) + ")";
						custom.style.paddingLeft = "0px";
						room.style.position = "";

						if (this.entity.dataMap.isExhibitionHall && this.entity.dataMap.bannerRotatingVideo) {
							if (!this.experience.dataMap.fitToHeight) {
								this.bannerRotatingMarginTop = this.$refs.roomView.clientHeight + "px";
							} else {
								this.bannerRotatingMarginTop = "calc(100vh - " + navHeight + "px)";
							}
						} else {
							this.bannerRotatingMarginTop = this.$refs.roomView.clientHeight + "px";
						}
					} else {
						this.$nextTick(function() {
							scale = (window.innerHeight-navHeight) / (1080 * 0.5);
							let height = (window.innerHeight-navHeight);
							if (!this.isShow) {
								if (this.$refs.background && this.$refs.background.clientHeight > (1080 * 0.5)) {
									scale = height/this.$refs.background.clientHeight;
								}
							} else {
								if (this.$refs.backgroundTransition && this.$refs.backgroundTransition.clientHeight > (1080 * 0.5)) {
									scale = height/this.$refs.backgroundTransition.clientHeight;
								}
							}
							custom.style.position = "relative";
							custom.style.paddingLeft = (document.body.clientWidth - Math.abs((960 - (1 - scale) * (1920 * 0.5))))/2 + "px";
							room.style.transform = "scale(" + scale + ")";
							room.style.position = "absolute";
							this.bannerRotatingMarginTop = height + "px";
						});
					}
				}

			} else {
				custom.style.paddingLeft = "0";
				this.btnSkipLeft = "calc(100vw - 80px)";
				this.$nextTick(() => {
					if ((this.experience.dataMap.fitToHeight || this.$store.state.isFitToWidth) && window.innerHeight > window.innerWidth) {
						scale = document.body.clientWidth / (1920 * 0.5);
					} else {
						scale = (window.innerHeight-navHeight) / (1080 * 0.5);
					}
					custom.style.height = (this.$refs.background.clientHeight * scale) + "px";
					let height = (window.innerHeight-navHeight);
					if (!this.isShow) {
						if (this.$refs.background && this.$refs.background.clientHeight > (1080 * 0.5) && window.innerHeight < window.innerWidth) {
							scale = height/this.$refs.background.clientHeight;
						}
						if (this.$refs.background && this.$refs.background.clientWidth != 0 && document.body.clientWidth > (this.$refs.background.clientWidth * scale)) {
							custom.style.paddingLeft = (document.body.clientWidth - Math.abs((960 - (1 - scale) * (1920 * 0.5))))/2 + "px";
						}
					} else {
						if (this.$refs.backgroundTransition && this.$refs.backgroundTransition.clientHeight > (1080 * 0.5) && window.innerHeight < window.innerWidth) {
							scale = height/this.$refs.backgroundTransition.clientHeight;
						}
						if (this.$refs.backgroundTransition.clientWidth != 0 && document.body.clientWidth > (this.$refs.backgroundTransition.clientWidth * scale)) {
							custom.style.paddingLeft = (document.body.clientWidth - Math.abs((960 - (1 - scale) * (1920 * 0.5))))/2 + "px";
						}
					}
					room.style.transform = "scale(" + scale + ")";
				});
				document.getElementsByClassName("v-main")[0].id = "room";
				this.bannerRotatingMarginTop = "5px";
				if (!this.$store.state.isFitToWidth) {
					if (this.$refs.background) {
						this.divFooterWidth = (this.$refs.background.clientWidth * scale) + 'px';
					}
				} else {
					this.divFooterWidth = window.innerWidth + 'px';
				}
			}
			if (this.isTheFirstLoad) {
				this.isTheFirstLoad = false;
				this.stopVideoTransition();
			}

			this.$nextTick(() => {
				if (this.$refs.background) {
					if (!this.isShow) {
						if (this.$vuetify.breakpoint.mobile){
							if (!this.$store.state.isFitToWidth) {
								this.divFooterWidth = (this.$refs.background.clientWidth*scale) + 'px';
								if (this.backgroundIsNotYoutubeOrVimeo) {
									this.footerWidth = '40%';
								}
							} else {
								this.divFooterWidth = window.innerWidth + 'px';
								this.footerWidth = 'auto';
							}
							document.getElementsByClassName("v-main__wrap")[0].scrollLeft = ((960*scale)-window.innerWidth)/2;
						} else {
							document.getElementsByClassName("v-main__wrap")[0].scrollLeft = ((this.$refs.background.clientWidth*scale)-window.innerWidth)/2;
						}
					} else {
						document.getElementsByClassName("v-main__wrap")[0].scrollLeft = ((this.$refs.backgroundTransition.clientWidth*scale)-window.innerWidth)/2;
					}
					// handle overflow when container width bigger than background width
					if (this.$refs.background) {
						room.style.maxWidth = "calc(100% - " + (room.getBoundingClientRect().width-this.$refs.background.width) + "px)";
					}
				}

				if (poster != null) {
					poster.style.width = (1920 * 100) / document.body.clientWidth + "vw";
				}
			});
		},
		fileDownload(linkTo){
			this.sendToGA(linkTo);
			let url = this.$root.asset(linkTo.value);

			if (linkTo.subType == "Dialog"){
				this.dialogFileDownload.id = linkTo.id;
				this.dialogFileDownload.fileName = this.$root.getFileNameFromUrl(url);
				this.dialogFileDownload.link = url;
				this.dialogFileDownload.show = true;
			} else {
				this.$root.executeFileDownload(linkTo);
			}
		},
		executeDownloadDialog(){
			let activityLog = {
				type: "Room_file_download_dialog",
				dataMap: {
					structureId: this.entity.id,
					linkToId: this.dialogFileDownload.id,
					room: this.entity.name ?? ''
				},
			};
			this.$root.saveActivityLog(activityLog);
			location.href = this.dialogFileDownload.link + "?download";
			this.closeDialogFileDownload();
		},
		closeDialogFileDownload(){
			this.dialogFileDownload.show = false;
			this.dialogFileDownload.fileName = null;
			this.dialogFileDownload.link = null;
		},
		listPoster() {
			axios.get("/system/poster/find?&experienceId=" + this.experience.id).then((response) => {
				this.posterOriList = response.data;
				this.getPosterSelectedList();
			});
		},
		getPosterSelectedList() {
			this.posterList = [];

			let tmpIds = Object.assign([], this.idPosterList);
			let tmpPosterList = [];
			for (let id of tmpIds) {
				let list = this.$root.clone(this.posterOriList);
				let poster = list.filter((item) => id == item.id)[0];
				if (poster != null) {
					for (let item of poster.posterDataList) {
						for (let item1 of item) {
							if (item1.type === "GALLERY") {
								let length = item1.images.length;
								// for hide default image
								item1.images.splice(length - 1, 1);
							}
						}
					}
					tmpPosterList.push(poster);
				}
			}

			if (this.searchPoster) {
				let list = this.$root.clone(tmpPosterList);
				tmpPosterList = [];

				for (let item of list) {
					if (item.name.toLowerCase().includes(this.searchPoster.toLowerCase())) {
						tmpPosterList.push(item);
					}
				}
			}

			this.posterList = tmpPosterList;
		},
		getPosterByPage(page) {
			let start = 0;
			let end = 0;

			if(this.$router.app._route.params.tenantSlug == 'theaestheticnexus') {
				start = (page-1) * 3;
				end = page * 3;
			} else {
				start = (page-1) * 4;
				end = page * 4;
			}

			if (this.posterList.length < end) {
				end = this.posterList.length;
			}

			let result = [];
			for (let i = start; i < end; i++) {
				result.push(this.posterList[i]);
			}
			return result;
		},
		cleanSearchPoster() {
			this.searchPoster = "";
			this.getPosterSelectedList();
		},
		posterShow(entity) {
			this.isPosterShow = true;
			this.entityPreview = this.$root.clone(entity);
		},
		openNewTab(url) {
			window.open(url, "blank");
		},
		download(name) {
			location.href = this.baseLocation + "/asset/file/" + name + "?download&time=" + new Date();
		},
		showDialogCarousel(value, index) {
			this.dialogCarousel.show = true;
			this.dialogCarousel.open = index;
			this.dialogCarousel.images = value;
		},
		closeDialog() {
			this.dialog = { show: false, title: null, content: null };
		},
		closeDialogUrl() {
			
			if(this.linktoEntity != null){
				if(this.linktoEntity.type=="URL" && this.linktoEntity.target == "Dialog"){

					this.saveLogs().then(() => {
						console.log("Logs saved successfully.");
						
						this.linktoEntity = null;
						clearInterval(this.intervalId);
						this.dialogUrl = { show: false, title: null, content: null };
						this.iframeControl('');
					}).catch(()=>{
						this.dialogUrl = { show: false, title: null, content: null };
						this.iframeControl('');
					});
				}
			} else {
				this.dialogUrl = { show: false, title: null, content: null };
				this.iframeControl('');
			}
			
        },
		maximizeDialogUrl() {
            this.isMaxDialog = true;
        },
		minimizeDialogUrl() {
            this.isMaxDialog = false;
        },
		stopVideoTransition(url) {
			this.vchat.isTransition = false;

			let type = this.$root.getVideoTypeByUrl(url);
			if (type == 'mp4') {
				var video = document.getElementById("videoTransition");
				video.pause();
				video.currentTime = 0;
			} else if (type == 'youtube') {
				this.$refs.backgroundTransition.player.pauseVideo();
				this.$refs.backgroundTransition.player.currentTime = 0;
			} else if (type == 'vimeo') {
				this.$refs.backgroundTransitionVimeo.pause();
				this.$refs.backgroundTransitionVimeo.currentTime = 0;
			}
			this.transitionThumbnail = "";

			this.isShow = false;
			if (this.tmpSlug) {
				this.entity.background = null;
				this.entity.introTransition = null;
				this.entity.outroTransition = null;
				this.entity.linkToDataList = [];
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/hall/" +
						this.tmpSlug
				);
			} else {
				this.calcScale();
			}

			this.$nextTick(() => {
				if (this.$vuetify.breakpoint.mobile){
					if (this.$refs.backgroundYoutube) {
						if (this.$refs.backgroundYoutube.player) {
							this.$refs.backgroundYoutube.player.playVideo();
						}
					}
				}
			});
		},
		transitionEnds(isYoutubeUrl) {
			this.vchat.isTransition = false;
			this.isShow = false;
			if (!isYoutubeUrl) {
				this.$refs.backgroundTransitionVimeo.pause();
				this.$refs.backgroundTransitionVimeo.currentTime = 0;
			}

			if (this.$root.isYoutubeUrl(this.entity.background)) {
				this.$nextTick(() => {
					if (this.$vuetify.breakpoint.mobile){
						this.$refs.backgroundYoutube.player.playVideo();
					}
				});
			}

			if (this.tmpSlug) {
				this.entity.background = null;
				this.entity.introTransition = null;
				this.entity.outroTransition = null;
				this.entity.linkToDataList = [];
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/hall/" +
						this.tmpSlug
				);
			}
		},
		playVideoTransition(url) {
			let type = this.$root.getVideoTypeByUrl(url);
			if (type == 'mp4') {
				var video = document.getElementById("videoTransition");
				video.play();
			} else if (type == 'youtube') {
				this.$refs.backgroundTransition.player.playVideo();
			} else if (type == 'vimeo') {
				this.$refs.backgroundTransitionVimeo.play();
			}
		},
		setShowBtnTransition(status) {
			if (status && this.tmpSlug) {
				if (this.entity.dataMap.outroTransition.autoplay) {
					this.showBtnTransition = false;
				}
			} else {
				this.showBtnTransition = status;
			}
		},
		replaceContent(content) {
			return content.replace(/{{user_first_name}}/g, this.$store.state.principal.firstName) //
				.replace(/{{user_last_name}}/g, this.$store.state.principal.lastName) //
				.replace(/{{user_email}}/g, this.$store.state.principal.email);
		},
		previousPage() {
			window.history.go(this.indexBack);
		},
		showTrainingDialog(entity) {
			this.sendToGA(entity);
			if (entity.type === 'Training') {
				this.dialogTraining.value = this.$vtrainingurl + "/account/?guid=" + this.vTrainingUserGUID + "&view=training&categories=" + entity.categories.filter(value => this.userModules.includes(value+"")).join("-");
			} else if (entity.type === 'Completed_Training') {
				this.dialogTraining.value = this.$vtrainingurl + "/account/?guid=" + this.vTrainingUserGUID + "&view=complete";
			}
			this.dialogTraining.show = true;
		},
		showClinicDialog(entity) {
			this.sendToGA(entity);
			this.dialogClinic.value = this.$vtrainingurl + "/account/manage-employees/?guid=" + this.vTrainingUserGUID +"&view=manage-employees";
			this.dialogClinic.show = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.entity.dataMap.isExhibitionHall) {
			to.query.boothBackground = this.entity.dataMap.boothBackground;
		}
		next();
	},
};
</script>